import React from "react";
import ChallengesInnerCard from "./ChallengesInnerCard";
import searchIcon from "../../../../assets/images/search.svg";
import { ChallengesCardProps } from "../types/Challenges.type";
import Coin_Icon from '../../../../assets/images/coin-icon.svg';
const ChallengesCard: React.FC<ChallengesCardProps> = ({
  suggestions,
  setSearchTerm,
  themeManager,
  completedActionIcon,
  incompletedActionIcon,
  showCoin,
  campaignXp,
  showCredits
}) => {
  const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchTerm(e.target.value);
  };


  return (
    <div
      style={themeManager.getChallengesCardStyles()}
      className="q_challenges_card_cont_main"
    >
      <div className="q_challenges_card_sub_heading_cont">
        <div
          style={themeManager.getHeadingStyles()}
          className="q_challenges_card_heading"
        >
          Task List
        </div>
        {showCoin === true && campaignXp && campaignXp > 0 && <div className="q_challenges_inner_card_points_cont">
          <img src={Coin_Icon} alt="coin" />
          <p className="q_challenges_inner_card_points">{campaignXp}</p>
        </div>}

        {showCredits === true && campaignXp && campaignXp > 0 &&
          <p className="q_challenges_inner_card_credits">{campaignXp} Credits</p>
        }
      </div>

      <div
        className="q_challenges_card_input_cont"
        style={themeManager.getSearchStyles()}
      >
        <input
          onChange={handleSearchChange}
          className="q_challenges_card_input"
          placeholder="Search for tasks..."
          style={themeManager.getSearchColorStyles()}
        />
        <img src={searchIcon} alt={searchIcon} />
      </div>

      <div className="q_challenges_card_cont">
        {suggestions.map((item) => (
          <ChallengesInnerCard
            key={item?.actionId}
            title={item.title}
            islockedIcon={
              item.progressPercent ? "challengesIcon1" : "challengesLock"
            }
            metricCount={item.metricCount}
            progressbarPercent={item.progressPercent}
            progressData={item.progressData}
            isLocked={item.isLocked}
            themeManager={themeManager}
            completed={item.completed || false}
            completedActionIcon={completedActionIcon}
            incompletedActionIcon={incompletedActionIcon}
            xp={item?.xp || 0}
            showCoin={showCoin}
            showCredits={showCredits}
          />
        ))}
      </div>
    </div>
  );
};

export default ChallengesCard;
